import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { ChatContainerComponent } from "../../../ai-components/chat";
import { ChatPanelHdrComponent } from "../../../ai-components/chat/components/chat-panel-hdr/chat-panel-hdr.component";
import type { ToolRendererConfig } from "../../../ai-components/chat/model/tool-data.types";
import type { AgentIdleState } from "../../../ai-components/chat/model/agent.types";
import { AiChatSessionService } from "../../../ai-components/chat/services/ai-chat-session.service";

/**
 * AI Assistant full-page view for the compound search display.
 * Shows the shared chat panel header (new chat, settings) above the chat container.
 */
@Component({
  selector: "app-compound-ai-view-display",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./ai-view-display.component.html",
  styleUrls: ["./ai-view-display.component.scss"],
  standalone: true,
  imports: [ChatContainerComponent, ChatPanelHdrComponent],
})
export class AiViewDisplayComponent {
  private readonly chatSession = inject(AiChatSessionService);

  /** The graph_id of the LangGraph agent to use. */
  @Input() agentId: string = "";

  /** Human-readable label shown in the chat header. */
  @Input() agentLabel: string = "AI Assistant";

  /** Optional custom tool renderers for inline tool call display. */
  @Input() toolRenderers: ToolRendererConfig[] = [];

  /** Idle-state config forwarded from the active AgentDefinition. */
  @Input() idleConfig: AgentIdleState | undefined = undefined;

  /** Emitted when the user closes the chat — parent should switch display mode. */
  @Output() close = new EventEmitter<void>();

  /** Direct reference to the shared signal — stable for Angular's OnPush tracking. */
  protected readonly currentThreadId = this.chatSession.threadId;

  /** Starts a new conversation by generating a fresh thread UUID. */
  protected startNewChat(): void {
    this.chatSession.startNewChat();
  }
}
